import React, { FC, Fragment, useContext, useEffect, useState } from 'react';

import { Checkbox, FormControlLabel } from '@material-ui/core';
import RadioButtonCheckedRoundedIcon from '@material-ui/icons/RadioButtonCheckedRounded';
import RadioButtonUncheckedRoundedIcon from '@material-ui/icons/RadioButtonUncheckedRounded';

import { GlobalContext } from '../../../../../store';
import { useRouteInfoState } from '../../../../../components/RouteInfo/Context/RouteInfo.context';

interface IProps {
  isMoneyBall: boolean;
}
export const PlayersPerTeam: FC<IProps> = props => {
  const { isMoneyBall } = props;
  const {
    actions: {
      adminEvents: { edit: editAdminEvent }
    },
    adminEvents: { current: event }
  } = useContext(GlobalContext);

  const { clubId, eventId } = useRouteInfoState();

  const [playersCountArray, setPlayersCountArray] = useState([2, 3, 4, 5]);

  const onChange = ({ target: { value: playersPerTeam } }: any) => {
    if (clubId) {
      editAdminEvent(clubId, {
        id: Number(eventId),
        playersPerTeam: Number(playersPerTeam)
      }).catch();
    }
  };

  useEffect(() => {
    if (isMoneyBall) {
      setPlayersCountArray([3, 4, 5]);
    }
  }, [isMoneyBall]);

  return (
    <div>
      <span className="format-label players-per-team">HOW MANY PLAYERS PER TEAM?</span>

      {playersCountArray.map((index: number) =>
        event ? (
          <FormControlLabel
            key={`formcontrol-players-per-team-${index}`}
            className="round-subformat-checkbox override"
            classes={{ label: 'label' }}
            control={
              <Checkbox
                className="check-considered-flight"
                id={`checkbox-players-per-team-${index}`}
                checked={event.playersPerTeam === index || (!event.playersPerTeam && index === 2)}
                onChange={onChange}
                icon={<RadioButtonUncheckedRoundedIcon fontSize="large" />}
                checkedIcon={<RadioButtonCheckedRoundedIcon fontSize="large" />}
                value={String(index)}
                color="primary"
              />
            }
            label={index}
          />
        ) : (
          <Fragment key={`formcontrol-players-per-team-${index}`} />
        )
      )}
    </div>
  );
};
